export default __webpack_public_path__ + "static/media/chuchuang_s.6f2c69db.png";